import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Challenge, listChallenges } from "../repository/challengeRepository";

const ChallengeList: React.FC = () => {
  const [challenges, setChallenges] = useState<Challenge[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listChallenges()
      .then(setChallenges)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="panel">Loading challenges…</div>;
  if (error) return <div className="panel error">{error}</div>;

  return (
    <div className="challenge-list">
      <h2>Challenges</h2>
      <p className="muted">
        Each challenge is a small coding problem over real 2025 MLB pitch data. Write JavaScript,
        run it against every pitcher's season, and see if you got it right.
      </p>
      <ul>
        {challenges.map((c) => (
          <li key={c.challenge_id}>
            <Link to={`/challenges/${c.challenge_id}`}>
              <span className="ch-order">#{c.order}</span>
              <span className="ch-title">{c.title}</span>
              <span className="ch-fn">{c.function_name}()</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChallengeList;
